// extracted by mini-css-extract-plugin
export default {"copyrightText":"frame__copyrightText__IeEm6q"};